export const OVERRIDE_AB_STORAGE_PREFIX = "hackle-manual-override_ab"
export const OVERRIDE_FF_STORAGE_PREFIX = "hackle-manual-override_ff"

export const DEVTOOLS_URL = "https://devtools.hackle.io"

export const DEVTOOLS_USER_EXPLORER_SUB_PATH = "/user-explorer"

export const HACKLE_LOGO_URL = "https://cdn.hackle.io/images/20230330/84a95e8b-339b-412e-9200-f3655b5eb91b.png"
